/* eslint-disable react-hooks/exhaustive-deps */
// export default IncidentRequest;
import Loading from "components/Loading";
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import { FaBriefcase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchOpeningCaseFile } from "services/caseServices";
import { OpeniningCaseFile, OpeniningCaseFileStatus } from "types";
import { eyeIcon } from "utils/constant";
import { DateView, errorHandler } from "utils/helper";
import PageHeader from "../../components/PageHeader";

const tabs = ["All"];

const OpeningCaseFileList: React.FC = () => {
  const { showTooltip } = useTooltip();
  const [activeTab, setActiveTab] = useState("All");
  const [courts, setCourts] = useState<OpeniningCaseFile[]>([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  // const [dateFilter, setDateFilter] = useState<
  //   string | number | readonly string[] | undefined
  // >();

  // const [caseTooltip, setCaseTooltip] = React.useState<OpeniningCaseFile>();
  // const [selectedCase, setSelectedCase] = React.useState<OpeniningCaseFile>();

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetchOpeningCaseFile()
      .then((data) => {
        setCourts(data);
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      });
  }, []);

  const searchTerm = search.trim().toLowerCase();
  const filteredInvestigations = courts.filter((investigation) => {
    // 1️⃣ — existing text‑search fields
    const prosecutor_registration_number =
      investigation?.prosecutor_registration_number
        ?.toString()
        ?.toLowerCase() || "";
    const status = investigation?.status?.toString()?.toLowerCase() || "";
    const incident_registration_no =
      investigation?.incident_registration_no?.toString()?.toLowerCase() || "";
    const crime_refernce_number =
      investigation?.crime_refernce_number?.toString()?.toLowerCase() || "";
    const first_court_hearing_date = investigation.first_court_hearing_date
      ? new Date(investigation.first_court_hearing_date)
          .toLocaleDateString()
          .toLowerCase()
      : "";
    const court_registration_number = investigation.court_registration_number;

    const matchesText =
      prosecutor_registration_number.includes(searchTerm) ||
      status.includes(searchTerm) ||
      incident_registration_no.includes(searchTerm) ||
      crime_refernce_number.includes(searchTerm) ||
      first_court_hearing_date.includes(searchTerm) ||
      court_registration_number.includes(searchTerm);

    return matchesText;
  });

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <PageHeader
        title="Court"
        icon={FaBriefcase}
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={setActiveTab}
        rightContent={
          <>
            {/* <input
              type="date"
              className="px-3 py-2 text-sm text-gray-600 border rounded"
              placeholder="Filter by Date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            /> */}
            {/* <button
              onClick={() => navigate("/incident-register")}
              className="px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
            >
              Register Incident
            </button> */}
          </>
        }
      />
      {/* {activeTab === "All" ? (
        <AllTab incidents={filteredIncidents} />
      ) : activeTab === "Approved" ? (
        <ApprovedTab />
      ) : activeTab === "Cancelled" ? (
        <CancelledTab />
      ) : null} */}

      <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
        <div className="overflow-hidden bg-white shadow rounded-xl">
          {loading ? (
            <Loading label="Loading Incidents" />
          ) : (
            <table className="w-full text-sm border-collapse">
              <thead className="text-white bg-black">
                <tr>
                  <th colSpan={8} className="p-4" rounded-t-lg>
                    <div className="flex items-center justify-between">
                      {/* Left: Back + Title */}
                      <div className="flex items-center gap-2 text-lg font-semibold">
                        <button
                          onClick={() => navigate(-1)}
                          className="text-white hover:text-gray-300"
                          title="Go Back"
                        >
                          ◀️
                        </button>
                        <span>Court Table</span>
                      </div>

                      {/* Right: Search Box */}
                      <div className="relative w-80">
                        <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                          🔍
                        </span>
                        <input
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search"
                          className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                        />
                      </div>
                    </div>
                  </th>
                </tr>
                <tr>
                  {/* <th className="p-3 text-left">Reporter</th> */}
                  <th className="p-3 text-left">Prosecutor Reg No</th>
                  <th className="p-3 text-left">Incident Reg No</th>
                  <th className="p-3 text-left">Crime Reference No</th>
                  <th className="p-3 text-left">Status</th>
                  <th className="p-3 text-left">Court Reg No</th>
                  <th className="p-3 text-left">First Hearing Date</th>
                  <th className="p-3 text-left">Detail</th>
                </tr>
              </thead>
              <tbody>
                {filteredInvestigations.map((item, idx) => (
                  <tr
                    key={idx}
                    className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                  >
                    <td className="p-3 font-[500] font-[Poppins]">
                      {item?.prosecutor_registration_number}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {item?.incident_registration_no}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {item.crime_refernce_number}
                    </td>
                    <td className="p-3 font-[500] font-[inter]">
                      {item?.status != null ? (
                        <div className="px-4 py-1 bg-[#33333321] font-[Poppins] rounded-2xl border border-[#3D3D3D] text-center">
                          {OpeniningCaseFileStatus[item?.status]}
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {item?.court_registration_number}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {DateView(item.first_court_hearing_date)}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      <button
                        onClick={() =>
                          navigate("/courts/" + item?.id, {
                            state: { caseData: item },
                          })
                        }
                      >
                        {eyeIcon}
                      </button>
                    </td>
                  </tr>
                ))}
                {courts.length === 0 && (
                  <tr>
                    <td colSpan={6} className="p-4 text-center text-gray-500">
                      No case found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpeningCaseFileList;
